<!-- Translated: yes -->
<template>
  <Modal @close="closeModal" :wide="false" width="500px">

    <h1>{{ $t('skipass.refill-header') }}</h1>

    <div class="blocked center">
      <p></p>
    </div>

    <div class="blocked center">
      <b>{{ $t('skipass.enter-number') }}</b>
      <br>
      <Dropdown
        :options="options"
        :valuebinder.sync="prefix"
        :validated="prefix"
        label="00"
        />
      <input type="tel" :class="{validated: validate(), error: error()}" v-mask="pattern" :placeholder="placeholder" v-model="number">
    </div>

    <div class="blocked center">
      <button @click="setNumber()" :disabled="!validate()">{{ $t('skipass.add-number') }}</button>
    </div>

    <div class="blocked info">
      <b><icon name="info" :scale="1.4" />{{ $t('skipass.old-keycard-title') }}</b>
      <p>{{ $t('skipass.old-keycard-text') }}</p>
    </div>

    <div class="blocked center keycard-img">
      <img src="https://static.booking.branasgruppen.se/static/img/liftkort-nr.jpg" />
    </div>

  </Modal>
</template>

<script>
import { mapMutations } from 'vuex';
import Modal from '@/components/components/Modal';
import CounterButton from '@/components/components/CounterButton';
import Dropdown from '@/components/components/Dropdown';
import AccomodationPeriodConfirm from '@/components/parts/Accomodation/AccomodationPeriodConfirm';

import checkdigit from 'checkdigit';

export default {
  props: {
    params: {},
  },
  components: {
    Modal,
    CounterButton,
    Dropdown,
    AccomodationPeriodConfirm,
  },
  data() {
    return {
      number: '',
      prefix: '',
      pattern: '####-####-####-####-####-#',
      placeholder: '0000-0000-0000-0000-0000-0',
    };
  },
  mounted() {
  },
  computed: {
    fullNumber() {
      return `${this.prefix}${this.number}`.replace(/-/g, '');
    },
    options() {
      return [
        {
          title: '01',
          value: '01',
        }, {
          title: '30',
          value: '30',
        },
      ];
    },
  },
  methods: {
    ...mapMutations([
      'closeModal',
      'closeAllModals',
      'openModal',
    ]),
    validate() {
      const validated = this.fullNumber ? checkdigit.mod10.isValid(this.fullNumber) : false;
      return this.fullNumber.length === 23 && validated;
    },
    error() {
      const validated = this.fullNumber ? checkdigit.mod10.isValid(this.fullNumber) : false;
      return this.fullNumber.length === 23 && !validated;
    },
    setNumber() {
      this.params.onSetNumber(this.prefix, this.number);
      this.closeModal();
    },
  },
};
</script>

<style scoped lang="stylus">
@import '~@/global.styl'


.dropdown-wrapper
  width 75px
  height: 50px
  display: inline-block;
  position: relative;
  top: 5px
  &.validated
    position: relative;
    top: 4px

.info
  border-radius 2px
  background-color rgba(199, 220, 183, 0.26)
  border solid 1px #d1e0c2
  padding 15px 27px
  margin-top: 30px
  +max-mobile()
    padding: 15px 10px!important
    margin-top: 10px

h1.accomodation-title
  font-size 19px
  font-weight bold
  text-align center
  color #262626
  text-transform none
  border-radius 2px
  background-color #ecf5f8
  border solid 1px #bfd9e1
  padding 7px 20px
  display inline-block


h1
  margin-bottom: 5px

.keycard-img img
  width: 200px

.blocked
  margin-bottom space-2
  width:374px;
  max-width:100%;
  margin-left: auto;
  margin-right: auto;

button
  font-size: 12px
  padding: 9px 20px 5px;

b
  uppercase()

input
  input()
  font-size: 13px;
  font-weight: 300;
  letter-spacing: 0.06em;
  color: rgba(38, 38, 38, 0.74);
  width 250px
  max-width 250px
  margin-top: 7px
  font-family: monospace;
  padding: 8px 10px 7px 10px;
  position: relative;
  top: 3px;

.info
  border-radius 2px
  background-color rgba(199, 220, 183, 0.26)
  border solid 1px #d1e0c2
  padding 15px 27px
  max-width 420px
  width 100%
  &.blue
    background-color: #ecf5f8;
    border 0
    text-align: center
  &.green
    margin-bottom: 0
  b
    font-size 11px
    font-weight bold
    color #1c1c1c
    display block
    margin-bottom 0.9em
    uppercase()
    .icon
      margin-right 0.7em
  p
    font-size 14px
    font-weight 300
    line-height 1.3
    color #262626
    margin 0
  &.small
    padding 10px 8px
    p
      font-size 11px
      color #1c1c1c

.padding
  padding 0 27px
h1
  margin-top 20px

input
  &.validated
    background-color: #5aa478;
    border-color #c7dcb7;
    color white
    uppercase()
  &.error
    border-color warning

select
  height 45px
  border-radius 4px
  background-color #ffffff
  border solid 2px #bfd9e1
  width 100%
</style>



// WEBPACK FOOTER //
// SkiPassRefill.vue?250f382b